import { Box, BoxProps, ColorOptions, IconNew as Icon, ModBox, Spacer, TextNew as Text } from '@jfs/ui-new'
import { CircularProgress } from './CircularProgress'

const FileSelectorInnerComp = ({
  innerCompTitle,
  innnerCompSubtitle,
  filename,
  isLoading = false,
  percent = 75,
  onCancelPress,
  fileId,
  showRemoveFile,
  error = '',
}: any) => {
  if (isLoading) {
    return (
      <Box {...styles.container}>
        <CircularProgress percentage={percent} strokeWidth={1} radius={36}>
          <ModBox show={percent < 90} {...styles.progressView}>
            <Icon id={'UPLOAD'} color={'BRAND_PRIMARY_GREEN'} size={24} />
          </ModBox>
          <ModBox show={percent === 100} {...styles.progressView}>
            <Icon id={'STATUS_SUCCESS'} color={'BRAND_PRIMARY_GREEN'} size={24} />
          </ModBox>
        </CircularProgress>
        <Spacer size={24} direction={'vertical'} />
        <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'}>
          {'Uploading your file, Please wait…'}
        </Text>
        <Spacer size={16} direction={'vertical'} />
        <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLUE'}>
          {'Cancel Upload'}
        </Text>
      </Box>
    )
  }
  return (
    <>
      <Box {...styles.container}>
        {!filename && (
          <>
            <Box {...styles.addContainer} borderStyle={'dashed'} borderWidth={1} borderColor={'BLUE'}>
              <Icon id={'ADD'} color={'BLUE'} size={24} />
            </Box>
            <Spacer size={24} direction={'vertical'} />
            <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'}>
              {innerCompTitle}
            </Text>
            {innnerCompSubtitle && (
              <Text fontFamily={'jiotype-medium'} fontSize={12} color={'PRIMARY_GREY'}>
                {'or'}
              </Text>
            )}
            <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLUE'}>
              {innnerCompSubtitle}
            </Text>
          </>
        )}
        {!!filename && (
          <>
            <Box
              {...styles.addContainer}
              borderWidth={1}
              borderColor={'BRAND_PRIMARY_GREEN'}
              bg={'#3F8C3A33' as ColorOptions}>
              <Icon id={'TICKMARK'} color={'BRAND_PRIMARY_GREEN'} size={24} />
            </Box>
            <Spacer size={24} direction={'vertical'} />
            <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'}>
              {`File Uploaded Successfully (${filename})`}
            </Text>
            <Spacer size={16} direction={'vertical'} />
            <ModBox onPress={onCancelPress} underlayColor={'TRANSPARENT'} show={showRemoveFile}>
              <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLUE'}>
                {'Remove File'}
              </Text>
            </ModBox>
          </>
        )}
        <ModBox show={error && error?.length > 0}>
          <Text fontFamily={'jiotype-medium'} fontSize={12} color={'RED'}>
            {error}
          </Text>
        </ModBox>
      </Box>
      <Spacer size={16} direction={'vertical'} />
    </>
  )
}

const styles = {
  container: {
    borderStyle: 'dashed',
    height: '250',
    width: '100%',
    paddingHorizontal: 'MEDIUM',
    borderWidth: 1,
    borderRadius: '4px',
    borderColor: '#0186B080' as ColorOptions,
    underlayColor: 'WHITE',
    align: 'center',
    justify: 'center',
    bg: '#0186B00A' as ColorOptions,
  } as BoxProps,
  progressView: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    width: 72,
    height: 72,
    alignItems: 'center',
    zIndex: 10000,
    justifyContent: 'center',
  } as BoxProps,
  addContainer: {
    width: '72px',
    height: '72px',
    borderRadius: '36px',
    align: 'center',
    justify: 'center',
  } as BoxProps,
}

export { FileSelectorInnerComp }
